import * as types from "./types";

export const login = () => ({
  type: types.AUTH_LOGIN
});

export const logout = () => ({
  type: types.AUTH_LOGOUT
});